import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { useAuth } from "contexts/AuthContext";

import StandardButton from "components/Common/buttons/StandardButton";
import { generateReportUrl } from "utils/report.utils";

type ItemProps = {
  subs: any;
  remove: Function;
};

const PTSummary: React.FC<ItemProps> = ({ subs, remove }) => {
  if (subs.length > 0) {
    return subs.map((sub, index) =>
      <Item key={`PT_SubscriptionsItem_${sub.pt_id}_${index}`} sub={sub} remove={remove} />
    );
  } else {
    return null;
  }
};

const Item = ({ sub, remove }) => {
  const { isSales } = useAuth();

  const [keep, setKeep] = useState<boolean>(false);
  const [date, setDate] = useState("N/A");

  const url = generateReportUrl(sub.pt_name);

  useEffect(() => {
    if (sub.date_added) {
      setDate(new Date(sub.date_added).toString());
    }
  }, []);

  function handleClick() {
    setKeep(!keep);
    remove(sub.pt_id);
  }


  if (isSales()) {
    return (
      <SubscriptionsItem $keep={keep}>
        <div>
          <Link
            to={`/medsku/dashboard/${sub.pt_id}/${url}`}
            target="_blank"
          >
            {sub.pt_name}
          </Link>
          <Small>Access assigned on: {date}</Small>
          <Small>{sub.pt_demo_id || sub.demo ? "Sample" : "Full"}</Small>
        </div>
      </SubscriptionsItem>
    );
  } else {
    return (
      <SubscriptionsItem $keep={keep}>
        <div>
          <Link
            to={`/medsku/dashboard/${sub.pt_id}/${url}`}
            target="_blank"
          >
            {sub.pt_name}
          </Link>
          <Small>Access assigned on: {date}</Small>
          <Small>{sub.pt_demo_id || sub.demo ? "Sample" : "Full"}</Small>
        </div>

        <StandardButton onClick={handleClick} size="xs" type={"button"}>
          {keep ? "Keep" : "Remove"}
        </StandardButton>
      </SubscriptionsItem>
    );
  }
}

const SubscriptionsItem = styled.div<{ $keep?: boolean; }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  padding: 1rem;

  div {
    width: 100%;
  }

  opacity: ${props => props.$keep ? 0.5 : 1};
  transition: 0.2s;
`;

const Small = styled.div`
  font-size: 1.5rem;
`;

export default PTSummary;
